import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { apiFetch } from './api'

export default function ChangePassword() {
  const [currentPassword, setCurrentPassword] = useState('')
  const [newPassword, setNewPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [msg, setMsg] = useState(null)
  const [tone, setTone] = useState('info')
  const [loading, setLoading] = useState(false)
  const nav = useNavigate()

  const submit = async e => {
    e.preventDefault()
    setMsg(null)
    if (newPassword !== confirmPassword) {
      setTone('error');
      setMsg('Passwords do not match');
      return;
    }
    setLoading(true)
    try {
      const res = await apiFetch('/api/change-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ currentPassword, newPassword })
      })
      if (res.ok) {
        setTone('success');
        setMsg('Password updated');
        setCurrentPassword('');
        setNewPassword('');
        setConfirmPassword('');
        setTimeout(() => nav('/dashboard'), 800)
      } else {
        const err = await res.json().catch(() => ({ error: 'Failed' }))
        setTone('error');
        setMsg(err.error || 'Failed to change password')
      }
    } catch (err) {
      setTone('error');
      setMsg('Network error')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="login-shell" style={{minHeight:'100vh', padding:20}}>
      <div className="auth-card" style={{maxWidth:480, width:'100%'}}>
        <h2 style={{marginTop:0, marginBottom:6}}>Change Password</h2>
        <p style={{marginTop:0, color:'#475569'}}>Enter your current password and choose a new one.</p>
        {msg && <div className={`auth-msg ${tone === 'error' ? 'error' : 'success'}`} style={{marginBottom:12}}>{msg}</div>}
        <form onSubmit={submit} className="auth-form">
          <div className="form-row">
            <label htmlFor="current">Current password</label>
            <input id="current" type="password" value={currentPassword} onChange={e=>setCurrentPassword(e.target.value)} required />
          </div>
          <div className="form-row">
            <label htmlFor="new">New password</label>
            <input id="new" type="password" value={newPassword} onChange={e=>setNewPassword(e.target.value)} required />
          </div>
          <div className="form-row">
            <label htmlFor="confirm">Confirm new password</label>
            <input id="confirm" type="password" value={confirmPassword} onChange={e=>setConfirmPassword(e.target.value)} required />
          </div>
          <div className="form-actions" style={{justifyContent:'space-between'}}>
            <button type="button" className="btn secondary" onClick={()=>nav('/dashboard')}>Cancel</button>
            <button className="btn primary" type="submit" disabled={loading}>{loading ? 'Saving…' : 'Change password'}</button>
          </div>
        </form>
      </div>
    </div>
  )
}
